module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Bi-wekly-ritual-Web-640.12b99102.jpg";